<template>
  <svg width="24"
       height="28"
       viewBox="0 0 24 28"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66667 23.1334C3.86667 21.9556 5.26134 21.028 6.85067 20.3507C8.44 19.6734 10.1564 19.3342 12 19.3334C13.8444 19.3334 15.5613 19.6725 17.1507 20.3507C18.74 21.0289 20.1342 21.9565 21.3333 23.1334V6.00002H2.66667V23.1334ZM12 16.6667C10.7111 16.6667 9.61111 16.2111 8.7 15.3C7.78889 14.3889 7.33334 13.2889 7.33334 12C7.33334 10.7111 7.78889 9.61113 8.7 8.70002C9.61111 7.78891 10.7111 7.33335 12 7.33335C13.2889 7.33335 14.3889 7.78891 15.3 8.70002C16.2111 9.61113 16.6667 10.7111 16.6667 12C16.6667 13.2889 16.2111 14.3889 15.3 15.3C14.3889 16.2111 13.2889 16.6667 12 16.6667ZM2.66667 27.3334C1.93334 27.3334 1.30534 27.072 0.782669 26.5494C0.260002 26.0267 -0.000886625 25.3991 2.26373e-06 24.6667V6.00002C2.26373e-06 5.26669 0.261336 4.63869 0.784002 4.11602C1.30667 3.59335 1.93422 3.33246 2.66667 3.33335H4V0.666687H6.66667V3.33335H17.3333V0.666687H20V3.33335H21.3333C22.0667 3.33335 22.6947 3.59469 23.2173 4.11735C23.74 4.64002 24.0009 5.26758 24 6.00002V24.6667C24 25.4 23.7387 26.028 23.216 26.5507C22.6933 27.0734 22.0658 27.3342 21.3333 27.3334H2.66667Z"
      fill="url(#paint0_linear_155_2305)" />
    <path
      d="M2.66667 23.1334C3.86667 21.9556 5.26134 21.028 6.85067 20.3507C8.44 19.6734 10.1564 19.3342 12 19.3334C13.8444 19.3334 15.5613 19.6725 17.1507 20.3507C18.74 21.0289 20.1342 21.9565 21.3333 23.1334V6.00002H2.66667V23.1334ZM12 16.6667C10.7111 16.6667 9.61111 16.2111 8.7 15.3C7.78889 14.3889 7.33334 13.2889 7.33334 12C7.33334 10.7111 7.78889 9.61113 8.7 8.70002C9.61111 7.78891 10.7111 7.33335 12 7.33335C13.2889 7.33335 14.3889 7.78891 15.3 8.70002C16.2111 9.61113 16.6667 10.7111 16.6667 12C16.6667 13.2889 16.2111 14.3889 15.3 15.3C14.3889 16.2111 13.2889 16.6667 12 16.6667ZM2.66667 27.3334C1.93334 27.3334 1.30534 27.072 0.782669 26.5494C0.260002 26.0267 -0.000886625 25.3991 2.26373e-06 24.6667V6.00002C2.26373e-06 5.26669 0.261336 4.63869 0.784002 4.11602C1.30667 3.59335 1.93422 3.33246 2.66667 3.33335H4V0.666687H6.66667V3.33335H17.3333V0.666687H20V3.33335H21.3333C22.0667 3.33335 22.6947 3.59469 23.2173 4.11735C23.74 4.64002 24.0009 5.26758 24 6.00002V24.6667C24 25.4 23.7387 26.028 23.216 26.5507C22.6933 27.0734 22.0658 27.3342 21.3333 27.3334H2.66667Z"
      fill="url(#paint0_linear_155_2305)"
      fill-opacity="0.2" />

    <defs>
      <linearGradient id="paint0_linear_155_2305"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
